const lfaCardColorMedia = {
  "banana-split-when-life-splits-t-shirt": {
    "Natural": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/LFA_Banana_Split_Natural_Front_Variant.png?v=1792587153",
      "width": 1600,
      "height": 2000,
      "alt": "When Life Splits You in Two Banana Split Tee — Natural"
    },
    "Light Blue": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/LFA_Banana_Split_Carolina_Blue_Front_Variant.png?v=1792587153",
      "width": 1600,
      "height": 2000,
      "alt": "When Life Splits You in Two Banana Split Tee — Light Blue"
    }
  },
  "donut-life-can-still-be-sweet-t-shirt": {
    "White": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/74528829-a135-47b3-9ce2-d0d31f6e5934.png?v=1792669987",
      "width": 1122,
      "height": 1402,
      "alt": "Life Can Still Be Sweet Donut Tee — White"
    },
    "Natural": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/bbeb7193-6a84-4be3-a0df-4de99f3c7da9.png?v=1792669986",
      "width": 1122,
      "height": 1402,
      "alt": "Life Can Still Be Sweet Donut Tee — Natural"
    },
    "Light Pink": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/070b9a1d-edf3-4262-9329-e3b39f39b286.png?v=1792669986",
      "width": 1122,
      "height": 1402,
      "alt": "Life Can Still Be Sweet Donut Tee — Light Pink"
    },
    "Sand": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/7870314d-5cf9-48c1-ae8d-1e0eb6cf14d6.png?v=1792669987",
      "width": 1122,
      "height": 1402,
      "alt": "Life Can Still Be Sweet Donut Tee — Sand"
    },
    "Black": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/2e32ea1c-6302-44a4-b944-bd1ad0b5f2b0.png?v=1792669986",
      "width": 1122,
      "height": 1402,
      "alt": "Life Can Still Be Sweet Donut Tee — Black"
    }
  },
  "chocolate-lava-cake-best-part-t-shirt": {
    "White": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/ChatGPTImageOct19_2026_06_11_02PM.png?v=1792504269",
      "width": 1122,
      "height": 1402,
      "alt": "Life Is Rich and Sweet Chocolate Lava Cake Tee — White"
    },
    "Natural": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/ba19a45e-8c55-42d1-a8d2-fc8a7da4a98d.png?v=1792504269",
      "width": 1122,
      "height": 1402,
      "alt": "Life Is Rich and Sweet Chocolate Lava Cake Tee — Natural"
    },
    "Light Pink": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/80c65dc9-f91f-4bf7-98f6-5833b3a86193.png?v=1792504268",
      "width": 1122,
      "height": 1402,
      "alt": "Life Is Rich and Sweet Chocolate Lava Cake Tee — Light Pink"
    },
    "Carolina Blue": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/2ccd9e46-f123-4bf6-8259-810bcd4601d2.png?v=1792504269",
      "width": 1122,
      "height": 1402,
      "alt": "Life Is Rich and Sweet Chocolate Lava Cake Tee — Carolina Blue"
    },
    "Navy": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/bfd7427a-5f2e-440d-a5e3-07289d2481a8.png?v=1792504269",
      "width": 1122,
      "height": 1402,
      "alt": "Life Is Rich and Sweet Chocolate Lava Cake Tee — Navy"
    },
    "Black": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/51f6bdc0-db38-4d11-8ff8-ffff20645b7e.png?v=1792504269",
      "width": 1122,
      "height": 1402,
      "alt": "Life Is Rich and Sweet Chocolate Lava Cake Tee — Black"
    }
  },
  "womens-vintage-lace-ghost-halloween-tee": {
    "Black": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/ChatGPT_Image_Sep_13_2026_05_35_29_PM_2.png?v=1789355592",
      "width": 1254,
      "height": 1254,
      "alt": "Women’s Vintage Lace Ghost Halloween Tee — Black"
    },
    "White": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/Women_s_Vintage_Lace_Ghost_Halloween_Tee_White.webp?v=1787367016",
      "width": 1080,
      "height": 1080,
      "alt": "Women’s Vintage Lace Ghost Halloween Tee — White"
    }
  },
  "white-spider-red-web-halloween-tee": {
    "Black": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/ChatGPT_Image_Sep_21_2026_06_39_34_PM.png?v=1790101518",
      "width": 1254,
      "height": 1254,
      "alt": "White Spider Red Web Halloween Tee — Black"
    }
  },
  "ice-cream-cone-enjoy-every-scoop-t-shirt": {
    "Sand": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/7b4fe46a-8d4d-4d7a-a2a8-8b35a268f002.png?v=1792669986",
      "width": 1122,
      "height": 1402,
      "alt": "Enjoy Every Scoop Ice Cream Cone Tee — Sand"
    }
  },
  "cherry-pie-a-little-sweetness-sweatshirt": {
    "Light Pink": {
      "src": "https://cdn.shopify.com/s/files/1/0423/0224/2966/files/8c9128c7-c372-4470-9499-bec2fc032d5b.png?v=1792504268",
      "width": 1122,
      "height": 1402,
      "alt": "Life Is Better With A Little Sweetness Cherry Pie Sweatshirt — Light Pink"
    }
  }
};

function handle(text) {
  return text
    .toString()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\_/g, '-')
    .replace(/\-\-+/g, '-')
    .replace(/\-$/g, '');
}

class ProductCardMini extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.image = this.querySelector('img[product-card-image]');
    this.imageContainerRatio = this.getAttribute(
      'image-container-ratio',
    ).trim();
    this.imageFit = this.hasAttribute('image-fit');
    this.quickShopTrigger = this.getAttribute('quick-shop-trigger');

    this._isRendered = this.hasAttribute('rendered');
  }

  set product(product) {
    this._product = product;
    if (!this._isRendered) {
      this._render();
    }
  }

  get product() {
    return this._product;
  }

  set sectionId(id) {
    this._sectionId = id;
  }

  get sectionId() {
    return this._sectionId;
  }

  _render() {
    this.setAttribute('product-id', this._product.id);

    // Match the initial card picture to its linked available variant.
    // Do not force a different color for single-variant products or products
    // whose main media is not associated with a particular variant.
    const firstCardMediaId = this._product.media?.[0]?.id;
    const picturedVariant = firstCardMediaId
      ? this._product.variants?.find((variant) =>
          variant.available &&
          (variant.featured_media?.id === firstCardMediaId ||
            variant.featured_image?.id === firstCardMediaId)
        )
      : null;
    const initialUrl = picturedVariant
      ? `${this._product.url}${this._product.url.includes('?') ? '&' : '?'}variant=${picturedVariant.id}`
      : this._product.url;
    this._currentVariantUrl = initialUrl;
    this.querySelectorAll('a[product-card-link]').forEach((link) =>
      link.setAttribute('href', initialUrl),
    );

    if (!this._product.available) {
      this.classList.add('product-card--sold-out');
    } else if (this._product.compare_at_price > this._product.price) {
      this.classList.add('product-card--sale');
    }

    if (this.imageContainerRatio === 'natural') {
      const previewImage = this.querySelector('img[product-card-image]');
      previewImage.closest('.o-ratio').style.paddingBottom = `100%`;
    }

    if (this.product.media && this.product.media.length > 0) {
      const mainImageSource = this.product.media[0].preview_image;

      this._updateImage(
        mainImageSource.src,
        mainImageSource.width,
        mainImageSource.height,
        mainImageSource.alt,
      );

      const secondaryImagePlaceholder = this.querySelector(
        'product-card-secondary-image-placeholder',
      );

      if (secondaryImagePlaceholder && this.product.media[1]) {
        const secondaryImageSource = this.product.media[1].preview_image;
        const secondaryImage = this._renderImage(
          secondaryImageSource.src,
          secondaryImageSource.width,
          secondaryImageSource.height,
          secondaryImagePlaceholder.getAttribute('class'),
          secondaryImageSource.alt,
          this.image.getAttribute('sizes'),
        );

        secondaryImage.setAttribute('product-card-secondary-image', '');

        this.image.parentElement.classList.add(
          'product-card__media--hover-image',
        );

        secondaryImagePlaceholder.replaceWith(secondaryImage);
      }

      if (this.getAttribute('image-hover') === 'zoom') {
        this.image.parentElement.classList.add(
          'product-card__media--hover-zoom',
        );
      }

      if (this.imageContainerRatio === 'natural') {
        this.image.closest('.o-ratio').style.paddingBottom = `${
          (1 / mainImageSource.aspect_ratio) * 100
        }%`;
      } else {
        this.image.closest('.o-ratio').style.paddingBottom = null;
      }

      this._updateSkeleton();
    }

    const vendor = this.querySelector('product-card-vendor');
    if (vendor) {
      vendor.textContent = this._product.vendor;
    }

    this.querySelector('product-card-title').textContent = this._product.title;

    const price = this.querySelector('product-card-price');
    if (price) {
      const variantPrice = `
        <span class="u-hidden-visually">${this._product.compare_at_price > this._product.price ? window.theme.t.sale_price : window.theme.t.regular_price}</span>
        <span class="price__number ${
          this._product.compare_at_price > this._product.price
            ? 'price__number--sale'
            : ''
        }">
          <span class="money">
          ${this._product.price_varies ? window.theme.t.from_price : ''}
          ${Shopify.formatMoney(this._product.price, window.theme.money_product_price_format)}
          </span>
        </span>
        ${
          this._product.compare_at_price > this._product.price
            ? `
              <span class="u-hidden-visually">${
                window.theme.t.regular_price
              }</span>
              <span class="price__compare">
                <span class="money">${Shopify.formatMoney(
                  this._product.compare_at_price,
                  theme.money_format,
                )}
                </span>
              </span>
            `
            : ''
        }
      `;

      price.innerHTML = variantPrice;
    }

    const priceNotes = this.querySelector('product-card-price-notes');
    const currentVariant = this._product.variants.find(
      (variant) => variant.available,
    );
    if (priceNotes && currentVariant && currentVariant.unit_price_measurement) {
      const priceNote = document.createElement('span');
      priceNote.classList.add('price__note', 'price__note--unit');

      const unitPriceTemplate = document.getElementById(
        'template-unit-price',
      ).content;
      priceNote.appendChild(unitPriceTemplate.cloneNode(true));

      priceNotes.appendChild(priceNote);

      const baseUnit = `${
        currentVariant.unit_price_measurement.reference_value !== 1
          ? currentVariant.unit_price_measurement.reference_value
          : ''
      }${currentVariant.unit_price_measurement.reference_unit}`;

      priceNotes.querySelector('unit-price').innerHTML =
        window.Shopify.formatMoney(
          currentVariant.unit_price,
          window.theme.money_format,
        );
      priceNotes.querySelector('base-unit').innerHTML = baseUnit;
    }

    // Quick shop triggers and add to cart buttons
    if (this.quickShopTrigger === 'button') {
      const productCardButton = this.querySelector('product-card-button');

      if (!this._product.available) {
        const soldOutButtonTemplate = document.getElementById(
          `${
            this._sectionId ? `${this._sectionId}--` : ''
          }template-sold-out-button`,
        ).content;

        const quickShopContainer = this.querySelector(
          'product-card-quick-shop',
        );

        if (quickShopContainer) quickShopContainer.remove();

        productCardButton.appendChild(soldOutButtonTemplate.cloneNode(true));
      } else if (this._product.variants && this._product.variants.length > 1) {
        const quickShopButtonTemplate = document.getElementById(
          `${
            this._sectionId ? `${this._sectionId}--` : ''
          }template-quick-shop-button`,
        ).content;
        const quickShopButton = quickShopButtonTemplate.cloneNode(true);

        const link = quickShopButton.querySelector('a');
        if (link) link.href = this._product.url;
        productCardButton.appendChild(quickShopButton);
      } else {
        const addToCartFormTemplate = document.getElementById(
          `${
            this._sectionId ? `${this._sectionId}--` : ''
          }template-add-to-cart-form`,
        ).content;
        const addToCartForm = addToCartFormTemplate.cloneNode(true);

        addToCartForm.querySelector('input[name="id"]').value =
          this._product.variants[0].id;

        const themeSpinnerTemplate =
          document.getElementById('template-spinner').content;
        const spinner = themeSpinnerTemplate.cloneNode(true);
        addToCartForm
          .querySelector('product-card-button-spinner')
          .appendChild(spinner);

        const quickShopContainer = this.querySelector(
          'product-card-quick-shop',
        );

        if (quickShopContainer) quickShopContainer.remove();

        productCardButton.appendChild(addToCartForm);
      }
    }

    const quickShopContainer = this.querySelector('product-card-quick-shop');
    if (
      quickShopContainer &&
      !(
        this.quickShopTrigger === 'button' &&
        (!this._product.available || this._product.variants.length === 1)
      )
    ) {
      const quickShopTemplate = document.getElementById(
        `${this._sectionId ? `${this._sectionId}--` : ''}template-quick-shop`,
      ).content;

      const quickShop = quickShopTemplate
        .cloneNode(true)
        .querySelector('quick-shop');

      if (quickShop.hasAttribute('placeholder')) {
        quickShop.setAttribute('data-product-url', this._product.url);
      }

      quickShopContainer.replaceWith(quickShop);
    }

    this.setAttribute('rendered', '');
    this._isRendered = true;
  }

  _renderImage(
    url,
    width,
    height,
    classes = '',
    alt = '',
    sizes = '100vw',
    srcsetWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512],
  ) {
    if (!url || !width || !height) return null;

    const image = document.createElement('img');
    const imageContainerRatio =
      this.imageContainerRatio !== 'natural'
        ? this.imageContainerRatio
            .split(':')
            .reduce((ratio, value) => (ratio !== 0 ? value / ratio : value), 0)
        : null;
    const aspectRatio = width / height;
    const uncroppedImage =
      this.imageContainerRatio === 'natural' ||
      (imageContainerRatio && this.imageFit);

    let masterWidth = width;
    let masterHeight = height;

    if (!uncroppedImage) {
      masterHeight = Math.round(masterWidth * imageContainerRatio);

      if (masterHeight > height) {
        masterHeight = height;
        masterWidth = Math.round(masterHeight / imageContainerRatio);
      }
    }

    const srcset = srcsetWidths.reduce((srcset, srcWidth) => {
      const srcHeight = Math.round(
        uncroppedImage
          ? srcWidth / aspectRatio
          : srcWidth * imageContainerRatio,
      );

      if (srcWidth > masterWidth || srcHeight > masterHeight) return srcset;

      return `${srcset}${url}${url.includes('?') ? '&' : '?'}width=${srcWidth}${
        !uncroppedImage ? `&height=${srcHeight}&crop=center` : ''
      } ${srcWidth}w ${srcHeight}h, `;
    }, '');

    const masterSrc = !uncroppedImage
      ? `${url}${
          url.includes('?') ? '&' : '?'
        }width=${masterWidth}&height=${masterHeight}&crop=center`
      : url;

    image.setAttribute('src', masterSrc);
    image.setAttribute('srcset', srcset);
    image.setAttribute('width', masterWidth);
    image.setAttribute('height', masterHeight);
    image.setAttribute('class', classes);
    image.setAttribute('alt', alt);
    image.setAttribute('sizes', sizes);

    return image;
  }

  _updateImage(
    url,
    width,
    height,
    alt = '',
    srcsetWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512],
  ) {
    if (!this.image || !url || !width || !height) return null;

    const imageContainerRatio =
      this.imageContainerRatio !== 'natural'
        ? this.imageContainerRatio
            .split(':')
            .reduce((ratio, value) => (ratio !== 0 ? value / ratio : value), 0)
        : null;
    const aspectRatio = width / height;
    const uncroppedImage =
      this.imageContainerRatio === 'natural' ||
      (imageContainerRatio && this.imageFit);

    let masterWidth = width;
    let masterHeight = height;

    if (!uncroppedImage) {
      masterHeight = Math.round(masterWidth * imageContainerRatio);

      if (masterHeight > height) {
        masterHeight = height;
        masterWidth = Math.round(masterHeight / imageContainerRatio);
      }
    }

    const srcset = srcsetWidths.reduce((srcset, srcWidth) => {
      const srcHeight = Math.round(
        uncroppedImage
          ? srcWidth / aspectRatio
          : srcWidth * imageContainerRatio,
      );

      if (srcWidth > masterWidth || srcHeight > masterHeight) return srcset;

      return `${srcset}${url}${url.includes('?') ? '&' : '?'}width=${srcWidth}${
        !uncroppedImage ? `&height=${srcHeight}&crop=center` : ''
      } ${srcWidth}w ${srcHeight}h, `;
    }, '');

    const masterSrc = !uncroppedImage
      ? `${url}${
          url.includes('?') ? '&' : '?'
        }width=${masterWidth}&height=${masterHeight}&crop=center`
      : url;

    this.image.setAttribute('src', masterSrc);
    this.image.setAttribute('srcset', srcset);
    this.image.setAttribute('width', masterWidth);
    this.image.setAttribute('height', masterHeight);
    this.image.setAttribute('alt', alt);
  }

  _updateSkeleton() {
    if (!this.image) return;

    const skeleton =
      this.image.nextElementSibling &&
      this.image.nextElementSibling.tagName.toLowerCase() === 'image-skeleton'
        ? this.image.nextElementSibling
        : null;

    if (skeleton) {
      const svg = skeleton.querySelector('svg');
      const rect = svg.querySelector('rect');
      const width = this.image.getAttribute('width');
      const height = this.image.getAttribute('height');
      skeleton.setAttribute(
        'aria-label',
        `Loading image for ${this._product.title}`,
      );
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', `0 0 ${width} ${height}`);

      rect.setAttribute('width', width);
      rect.setAttribute('height', height);
    }
  }
}
customElements.define('product-card-mini', ProductCardMini);

class ProductCard extends ProductCardMini {
  constructor() {
    super();

    this._boundSetVariant = this.setVariant.bind(this);
    this._boundPreloadSwatch = (event) => {
      const media = this._imageForSwatch(event.currentTarget);
      if (media) this._preloadColorImage(media);
    };
    this._boundSwatchKey = (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.setVariant(event);
      }
    };
  }

  connectedCallback() {
    super.connectedCallback();

    this._swatchTriggers = [];

    if (this._product && !this._isRendered) {
      this._currentVariantUrl = this._product.url;
      this._render();
    }

    if (this._swatchTriggers.length === 0) {
      this._swatchTriggers = Array.from(
        this.querySelectorAll('li[variant-id]'),
      );
    }

    if (!this._product) {
      this._setProductData();
    }

    this._setUpSwatchesListeners();
  }

  disconnectedCallback() {
    this._removeSwatchesListeners();
  }

  set product(product) {
    super.product = product;

    if (!this._isRendered) {
      this._currentVariantUrl = this._product.url;
      this._setUpSwatchesListeners();
    }
  }

  get product() {
    return this._product;
  }

  _render() {
    super._render();

    const swatches = this.querySelector('product-card-variant-swatches');
    if (swatches) {
      const swatchOption = this._product.options.find((option) =>
        theme.swatches.triggers.includes(option.name.toLowerCase()),
      );

      if (swatchOption) {
        const availableValues = swatchOption.values.filter((value) => this._product.variants.some((variant) => variant.available && variant[`option${swatchOption.position}`] === value));
        const templateId = this._sectionId
          ? `${this._sectionId}--template-swatch`
          : 'template-swatch';
        const swatchTemplate = document.getElementById(templateId).content;
        swatches.innerHTML = `
          <div class="swatch-wrapper">
            <div class="product-card__swatch">
              <ul class="product-card__swatch__items o-list-inline">
              </ul>
              ${
                availableValues.length > 5
                  ? `
                    <div class="product-card__overflow">
                      <a product-card-link href="${
                        this._product.url
                      }" class="product-card__overflow__item" title="${
                        this._product.title
                      }">
                        <span class="">+${availableValues.length - 5}</span>
                      </a>
                    </div>
                  `
                  : ''
              }
            </div>
          </div>
        `;

        const swatchList = swatches.querySelector('ul');
        availableValues.slice(0, 5).forEach((value) => {
          const variant = this._product.variants.find(
            (v) => v.available && v[`option${swatchOption.position}`] === value,
          );

          if (variant) {
            const variantId = variant.id;
            const swatchFragment = swatchTemplate.cloneNode(true);
            const variantNameHandle = handle(value);

            const variantSwatch =
              swatchFragment.querySelector('variant-swatch');
            variantSwatch.setAttribute('swatch-id', variantNameHandle);
            variantSwatch.style.setProperty(
              '--background-graphic',
              theme.swatches.colors[variantNameHandle] || variantNameHandle.replaceAll('-', ''),
            );
            variantSwatch.setAttribute('aria-label', value.replaceAll('"', ''));

            const variantTrigger = swatchFragment.querySelector('li');
            variantTrigger.setAttribute('variant-id', variantId);
            variantTrigger.setAttribute('role', 'button');
            variantTrigger.setAttribute('aria-pressed', 'false');
            variantTrigger.setAttribute('tabindex', '0');
            variantTrigger.setAttribute('aria-label', value);

            this._swatchTriggers.push(variantTrigger);

            swatchList.appendChild(swatchFragment);
          }
        });
      }
    }
  }

  _setProductData() {
    const productData = this.querySelector('[id^=ProductJson]');
    if (productData) this._product = JSON.parse(productData.textContent);
  }

  setVariant(e) {
    const trigger = e.currentTarget?.hasAttribute('variant-id') ? e.currentTarget : e.target.closest('[variant-id]');
    if (!trigger) return;

    const variantId = trigger.getAttribute('variant-id');
    const variant = this._product.variants.find(
      (v) => v.id.toString() === variantId,
    );

    if (variant) {
      this.querySelectorAll('li.is-active').forEach((li) =>
        li.classList.remove('is-active'),
      );
      this.querySelectorAll('[variant-id][role="button"]').forEach((swatch) =>
        swatch.setAttribute('aria-pressed', swatch === trigger ? 'true' : 'false'),
      );
      trigger.classList.add('is-active');

      this._currentVariantUrl = `${this._product.url}${
        this._product.url.includes('?') ? '&' : '?'
      }variant=${variantId}`;
      const colorIndex = (this._product.options || []).findIndex((option) =>
        theme.swatches.triggers.includes(
          (typeof option === 'string' ? option : option.name).toLowerCase(),
        ),
      );
      const color = colorIndex >= 0
        ? variant.options?.[colorIndex] ?? variant[`option${colorIndex + 1}`]
        : null;
      const mappedImage = lfaCardColorMedia[this._product.handle]?.[color];
      const variantImage = mappedImage ||
        variant.featured_media?.preview_image ||
        variant.featured_image ||
        this._product.media?.[0]?.preview_image ||
        null;

      this.querySelectorAll('a[product-card-link]').forEach((link) =>
        link.setAttribute('href', this._currentVariantUrl),
      );

      // Keep the current image in place until the next color has loaded.
      // A sequence token prevents an older image request from winning on rapid taps.
      this._queueMediaSwap(variantImage);

      const quickShop = this.querySelector('quick-shop');

      if (quickShop) {
        quickShop.variantId = variantId;
      }
    }
  }

  _imageForSwatch(trigger) {
    const variant = this._product?.variants?.find(
      (item) => item.id.toString() === trigger.getAttribute('variant-id'),
    );
    if (!variant) return null;
    const index = (this._product.options || []).findIndex((option) =>
      theme.swatches.triggers.includes(
        (typeof option === 'string' ? option : option.name).toLowerCase(),
      ),
    );
    const color = index >= 0
      ? variant.options?.[index] ?? variant[`option${index + 1}`]
      : null;
    return lfaCardColorMedia[this._product.handle]?.[color] ||
      variant.featured_media?.preview_image ||
      variant.featured_image ||
      this._product.media?.[0]?.preview_image ||
      null;
  }

  _preloadColorImage(media) {
    if (!media?.src || !media.width || !media.height || !this.image) {
      return Promise.resolve(false);
    }
    this._lfaPreloadCache ||= new Map();
    const key = `${media.src}|${media.width}|${media.height}`;
    if (this._lfaPreloadCache.has(key)) return this._lfaPreloadCache.get(key);

    const promise = new Promise((resolve) => {
      const preload = this._renderImage(
        media.src, media.width, media.height, '',
        media.alt || '', this.image.getAttribute('sizes') || '100vw',
      );
      if (!preload) { resolve(false); return; }
      const finish = () => {
        if (typeof preload.decode === 'function') {
          preload.decode().then(() => resolve(true)).catch(() => resolve(preload.naturalWidth > 0));
        } else {
          resolve(true);
        }
      };
      preload.addEventListener('load', finish, { once: true });
      preload.addEventListener('error', () => resolve(false), { once: true });
      if (preload.complete) {
        if (preload.naturalWidth > 0) finish();
        else resolve(false);
      }
    });
    this._lfaPreloadCache.set(key, promise);
    promise.then((ready) => {
      if (!ready) this._lfaPreloadCache.delete(key);
    });
    return promise;
  }

  _queueMediaSwap(media) {
    this._lfaSwapToken = (this._lfaSwapToken || 0) + 1;
    const token = this._lfaSwapToken;
    if (!media?.src || !this.image) return;
    const current = this._lfaVisibleMediaSrc ||
      this._product.media?.[0]?.preview_image?.src || null;
    if (media.src === current) return;
    this._preloadColorImage(media).then((ready) => {
      if (token !== this._lfaSwapToken || !this.isConnected || !ready) return;
      this._updateImage(media.src, media.width, media.height, media.alt || '');
      this._lfaVisibleMediaSrc = media.src;
    });
  }

  _setUpSwatchesListeners() {
    this._swatchTriggers.forEach((trigger) => {
      trigger.addEventListener('click', this._boundSetVariant);
      trigger.addEventListener('keydown', this._boundSwatchKey);
      // Prefetch only when a customer shows interest in a specific color.
      trigger.addEventListener('pointerenter', this._boundPreloadSwatch);
      trigger.addEventListener('focus', this._boundPreloadSwatch);
    });
  }

  _removeSwatchesListeners() {
    this._swatchTriggers.forEach((trigger) => {
      trigger.removeEventListener('click', this._boundSetVariant);
      trigger.removeEventListener('keydown', this._boundSwatchKey);
      trigger.removeEventListener('pointerenter', this._boundPreloadSwatch);
      trigger.removeEventListener('focus', this._boundPreloadSwatch);
    });
  }
}
customElements.define('product-card', ProductCard);


